import { yupResolver } from '@hookform/resolvers/yup'
import React, { useContext, useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import Select from 'react-select'
import { adminControlSchema } from '../../util/validationSchema'
import { useDispatch, useSelector } from 'react-redux'
import { SpinnerContext } from '../../context/spinnerContext'
import { addAdmin, editAdmin, getAdminByID } from '../../redux/slices/adminControlSlice'
import { errorToast, successToast } from '../../util/Toast/toast'
import { Form } from 'react-bootstrap'
import DropzoneController from '../../component/dropzone'
import {
  acceptExtensions,
  capitalizeAndRemoveUnderscore,
  capitalizeFirstLetter,
  formatPhoneNumbertoString,
  maskPhoneNumber
} from '../../helper/function'
import { IMAGE_MODULE } from '../../util/constant'
import InputMask from 'react-input-mask'

const defultValues = {
  first_name: '',
  last_name: '',
  email: '',
  contact_no: '',
  personal_address: '',
  regions: [],
  profile_image: []
}

const AddEditAdminControl = ({ adminID, editData, toggle, setIsRefresh }) => {
  const dispatch = useDispatch()
  const { changeLoader } = useContext(SpinnerContext)
  const { allRegion } = useSelector(({ region }) => region)
  const { allAdminRole } = useSelector(({ adminControl }) => adminControl)
  const [editAdminData, setEditAdminData] = useState(editData)
  const [showPassword, setShowPassword] = useState(false)
  const [showConfirmPassword, setShowConfirmPassword] = useState(false)
  const onPasswordEyeClick = () => setShowPassword(!showPassword)
  const onConfirmPasswordEyeClick = () => setShowConfirmPassword(!showConfirmPassword)

  useEffect(() => {
    if (editAdminData) {
      setValue('profile_image', [editAdminData?.profile_image])
    }
  }, [editAdminData])

  const updatedValues = adminID
    ? {
        first_name: editAdminData?.first_name || '',
        last_name: editAdminData?.last_name || '',
        email: editAdminData?.email || '',
        is_change_password: editAdminData && editAdminData?.is_change_password,
        contact_no: maskPhoneNumber(editAdminData?.contact_no) || '', // Masked phone number
        personal_address: editAdminData?.personal_address || '',
        admin_type: editAdminData ? { key: editAdminData?.admin_type, value: editAdminData?.admin_type } : null,
        regions: (editAdminData && editAdminData?.adminRegion.map((item) => item?.region?.region_id)) || [],
        profile_image: [editAdminData?.profile_image] || []
      }
    : defultValues

  const {
    handleSubmit,
    control,
    setValue,
    trigger,
    watch,
    reset,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(adminControlSchema),
    defaultValues: updatedValues
  })

  useEffect(() => {
    if (adminID && editAdminData) {
      reset(updatedValues)
    } else {
      reset(defultValues)
    }
  }, [editAdminData, reset, adminID])

  useEffect(() => {
    if (adminID) {
      dispatch(getAdminByID(adminID))
        .then(({ payload }) => {
          if (payload?.status === 200) {
            setEditAdminData(payload?.data?.data)
            changeLoader(false)
          } else {
            changeLoader(false)
          }
        })
        .catch(() => {
          changeLoader(false)
        })
    }
  }, [])

  const onSubmit = (data) => {
    setIsRefresh(false)
    const payload = {
      ...data,
      regions: data?.regions,
      profile_image: data?.profile_image?.[0],
      contact_no: formatPhoneNumbertoString(data?.contact_no),
      admin_type: data?.admin_type?.value
    }
    changeLoader(true)
    if (adminID) {
      const payloaddata = {
        data: payload,
        admin_id: adminID
      }
      delete payloaddata?.data?.email
      dispatch(editAdmin(payloaddata))
        .then(({ payload, error }) => {
          if (payload?.status === 200) {
            toggle()
            changeLoader(false)
            setIsRefresh(true)
            successToast(payload?.data?.status_message || 'Success!')
          } else {
            errorToast(payload?.data?.status_message || error?.message)
            changeLoader(false)
          }
        })
        .catch(() => {
          changeLoader(false)
        })
    } else {
      dispatch(addAdmin(payload))
        .then(({ payload, error }) => {
          if (payload?.status === 200) {
            toggle()
            changeLoader(false)
            setIsRefresh(true)
            successToast(payload?.data?.status_message || 'Success!')
          } else {
            errorToast(payload?.data?.status_message || error?.message)
            changeLoader(false)
          }
        })
        .catch(() => {
          changeLoader(false)
        })
    }
  }

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-md-12">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="card-body add-vendor pb-4">
              <div className="form-group-item border-0 pb-0 mb-0">
                <div className="row">
                  <div className="col-lg-6 col-sm-12">
                    <div className="form-group">
                      <label>
                        First Name<span className="text-danger"> *</span>
                      </label>
                      <Controller
                        name="first_name"
                        control={control}
                        render={({ field: { value, onChange } }) => (
                          <>
                            <input
                              className="form-control"
                              value={value}
                              type="text"
                              placeholder="First Name"
                              onChange={(val) => {
                                const input = val.target.value
                                const capitalized = capitalizeFirstLetter(input)
                                onChange(capitalized)
                                trigger('first_name')
                              }}
                            />
                            <small>{errors.first_name?.message}</small>
                          </>
                        )}
                        defaultValue=""
                      />
                    </div>
                  </div>
                  <div className="col-lg-6 col-sm-12">
                    <div className="form-group">
                      <label>
                        Last Name<span className="text-danger"> *</span>
                      </label>
                      <Controller
                        name="last_name"
                        control={control}
                        render={({ field: { value, onChange } }) => (
                          <>
                            <input
                              className="form-control"
                              value={value}
                              type="text"
                              placeholder="Last Name"
                              onChange={(val) => {
                                const input = val.target.value
                                const capitalized = capitalizeFirstLetter(input)
                                onChange(capitalized)
                                trigger('last_name')
                              }}
                            />
                            <small>{errors.last_name?.message}</small>
                          </>
                        )}
                        defaultValue=""
                      />
                    </div>
                  </div>

                  <div className="col-lg-12 col-sm-12">
                    <div className="form-group">
                      <label>
                        Email<span className="text-danger"> *</span>
                      </label>
                      <Controller
                        name="email"
                        control={control}
                        render={({ field: { value, onChange } }) => (
                          <>
                            <input
                              className="form-control"
                              autoComplete="off"
                              value={value}
                              type="text"
                              placeholder="Enter Email Address"
                              disabled={adminID ? true : false}
                              onChange={(val) => {
                                onChange(val)
                                trigger('email')
                              }}
                            />
                            <small>{errors.email?.message}</small>
                          </>
                        )}
                        defaultValue=""
                      />
                    </div>
                  </div>
                  {watch('is_change_password') && (
                    <>
                      <div className="col-lg-12 col-12">
                        <div className="form-group input_text">
                          <label className="form-control-label">Password</label>
                          <span className="text-danger"> *</span>
                          <Controller
                            name="password"
                            control={control}
                            render={({ field: { value, onChange } }) => (
                              <div className="pass-group">
                                <input
                                  type={showPassword ? 'text' : 'password'}
                                  className={`form-control  ${errors?.password ? 'error-input' : ''}`}
                                  value={value}
                                  onChange={onChange}
                                  autoComplete="false"
                                  placeholder="Enter Password"
                                  onCopy={(e) => e.preventDefault()} // Disable copy
                                  onCut={(e) => e.preventDefault()} // Disable cut
                                />
                                <span onClick={onPasswordEyeClick} className={`fa toggle-password ${showPassword ? 'fa-eye' : 'fa-eye-slash'}`} />
                              </div>
                            )}
                            defaultValue=""
                          />

                          <small>{errors?.password?.message}</small>
                        </div>
                      </div>

                      <div className="col-lg-12 col-12">
                        <div className="form-group input_text">
                          <label className="form-control-label">Confirm Password</label>
                          <span className="text-danger"> *</span>
                          <Controller
                            name="confirmPassword"
                            control={control}
                            render={({ field: { value, onChange } }) => (
                              <div className="pass-group">
                                <input
                                  type={showConfirmPassword ? 'text' : 'password'}
                                  className={`form-control  ${errors?.confirmPassword ? 'error-input' : ''}`}
                                  value={value}
                                  onChange={onChange}
                                  autoComplete="false"
                                  placeholder="Enter Confirm Password"
                                  onCopy={(e) => e.preventDefault()} // Disable copy
                                  onPaste={(e) => e.preventDefault()} // Disable paste
                                  onCut={(e) => e.preventDefault()} // Disable cut
                                />
                                <span
                                  onClick={onConfirmPasswordEyeClick}
                                  className={`fa toggle-password ${showConfirmPassword ? 'fa-eye' : 'fa-eye-slash'}`}
                                />
                              </div>
                            )}
                            defaultValue=""
                          />
                          <small>{errors?.confirmPassword?.message}</small>
                        </div>
                      </div>
                    </>
                  )}

                  {adminID && (
                    <div className="col-lg-12 col-sm-12">
                      <div className="form-group">
                        <Controller
                          name="is_change_password"
                          control={control}
                          defaultValue={false}
                          render={({ field }) => (
                            <>
                              <Form.Check
                                type="switch"
                                id="custom-switch"
                                label={`Change Password?`}
                                {...field}
                                checked={field.value} // ensures checked state is bound to value
                              />
                            </>
                          )}
                        />
                      </div>
                    </div>
                  )}

                  {/* Admin Type Dropdown */}
                  <div className="col-lg-12 col-sm-12">
                    <div className="form-group input_text">
                      <label>
                        Admin Type
                        <span className="text-danger"> *</span>
                      </label>
                      <Controller
                        name="admin_type"
                        control={control}
                        render={({ field }) => (
                          <Select
                            {...field}
                            className={`react-selectcomponent form-control ${errors?.admin_type?.value ? 'error-input' : ''}`}
                            options={allAdminRole}
                            getOptionLabel={(option) => capitalizeAndRemoveUnderscore(option?.key)}
                            getOptionValue={(option) => option?.key}
                            isClearable
                            isSearchable={true}
                            placeholder="Select Admin Type"
                            classNamePrefix="select_kanakku"
                            defaultValue={editAdminData ? { key: editAdminData?.admin_type, value: editAdminData?.admin_type } : null}
                            onChange={(selectedOption) => {
                              field.onChange(selectedOption)
                              trigger('regions')
                            }}
                            // value={field?.value ? { value: field?.value, key: field?.value.charAt(0).toUpperCase() + field.value.slice(1) } : null}
                          />
                        )}
                      />
                      <small className="text-danger">{errors?.admin_type?.value?.message}</small>
                    </div>
                  </div>
                  <div className="col-lg-12 col-sm-12">
                    <div className="form-group input_text">
                      <label>
                        Region
                        {watch('admin_type')?.value !== 'admin' && <span className="text-danger"> *</span>}
                      </label>
                      <Controller
                        name="regions"
                        control={control}
                        render={({ field }) => (
                          <Select
                            {...field}
                            className={`react-selectcomponent form-control ${errors?.regions ? 'error-input' : ''}`}
                            getOptionLabel={(option) => option.region || ''} // Ensure that you handle undefined options
                            getOptionValue={(option) => option.region_id || ''} // Ensure that you handle undefined options
                            options={allRegion || []}
                            isSearchable={true}
                            isClearable
                            isMulti // Enables multiple selection
                            placeholder="Select Region"
                            classNamePrefix="select_kanakku"
                            onChange={(selectedOptions) => {
                              // Map the selected options to an array of region IDs
                              const selectedRegionIds = selectedOptions.map((option) => option.region_id)
                              field.onChange(selectedRegionIds) // Update the field value with the array of IDs
                            }}
                            // You can handle the default value if needed
                            value={allRegion.filter((region) => field?.value?.includes(region.region_id))} // Filter to show selected regions
                          />
                        )}
                      />
                      <small className="text-danger">{errors?.regions?.message}</small> {/* Add class for styling */}
                    </div>
                  </div>

                  <div className="col-lg-12 col-12">
                    <div className="form-group input_text">
                      <label>Phone Number</label>
                      <Controller
                        name="contact_no"
                        control={control}
                        render={({ field: { value, onChange } }) => (
                          <InputMask
                            mask="(999) 999-9999" // Mask format
                            value={value}
                            onChange={onChange}
                            className={`form-control ${errors?.contact_no ? 'error-input' : ''}`}
                            placeholder="Enter Phone Number"
                            autoComplete="off"
                          >
                            {(inputProps) => <input {...inputProps} />}
                          </InputMask>
                        )}
                        defaultValue=""
                      />
                      <small>{errors?.contact_no?.message}</small>
                    </div>
                  </div>
                  <div className="col-lg-12 col-12">
                    <div className="form-group input_text">
                      <label>Address</label>
                      <Controller
                        name="personal_address"
                        control={control}
                        render={({ field: { value, onChange } }) => (
                          <textarea
                            className={`form-control ${errors?.personal_address ? 'error-input' : ''}`}
                            type="text"
                            value={value || ''}
                            onChange={onChange}
                            placeholder="Enter Address"
                            autoComplete="false"
                            rows="2"
                          ></textarea>
                        )}
                        defaultValue=""
                      />
                      <small>{errors?.personal_address?.message}</small>
                    </div>
                  </div>
                  <div className="col-lg-12 col-sm-12">
                    <div className="form-group">
                      <label>Profile Image</label>
                      <DropzoneController
                        name="profile_image"
                        maxFiles={1}
                        acceptExtensions={acceptExtensions}
                        control={control}
                        isSingleUpload={true}
                        files={watch('profile_image')}
                        isEditImage={adminID ? true : false}
                        module={IMAGE_MODULE.ADMIN}
                        isAddMode={adminID ? false : true}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="multi_btn_div">
                <button type="button" className="btn common-outline-btn w-100" onClick={() => toggle()}>
                  Cancel
                </button>
                <button type="submit" className="btn btn-primary common-field-btn w-100">
                  {adminID ? `Update` : `Create`}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default AddEditAdminControl
